import {Serialisable} from "../serialisable";

export class DashboardAlertDto extends Serialisable {
    device: string;
    message: string;
    branchId: number;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/dtos/dashboard-alert.dto.ts